<template>
  <el-dialog custom-class="support-create-container dialog-size-middle"
             title="お問合せ内容の作成"
             top="0"
             :modal="false"
             :append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
  <form-container ref="form" style="overflow-y: scroll; height: 480px;">
    <form-item-container label="カテゴリー">
      <span slot="form-item-label">カテゴリー<span class="required">*</span></span>
      <field-container v-if="supportId === null" style="justify-content: center">
        <field-select name="categoryId" v-model="categoryId" placeholder="カテゴリーを選択してください" validate="required" validateLabel="カテゴリー">
          <el-option v-for="supportCategory in supportCategories" :key="supportCategory.categoryId" :label="supportCategory.categoryName" :value="supportCategory.categoryId"></el-option>
        </field-select>
      </field-container>
      <template v-else>{{categoryName}}</template>
    </form-item-container>
    <form-item-container label="件名">
      <span slot="form-item-label">件名<span class="required">*</span></span>
      <field-container v-if="supportId === null">
        <field-input name="subject" v-model="subject" placeholder="件名を入力してください" validate="required|max:100" validateLabel="件名"></field-input>
      </field-container>
      <template v-else>{{subject}}</template>
    </form-item-container>
    <form-item-container label="本文">
      <span slot="form-item-label">本文<span class="required">*</span></span>
      <field-container>
        <field-textarea name="body" v-model="body" placeholder="本文を入力してください" validate="required|max:5000" validateLabel="本文"></field-textarea>
      </field-container>
    </form-item-container>
    <form-item-container label="添付ファイル" tip="添付できるファイルは下記になります\n・画像ファイル(jpg, jpeg, png, gif)\n・ドキュメントファイル(doc, docx, xls, xlsx, ppt, pptx, pdf)\n・テキストファイル(txt, csv)\n・圧縮ファイル(zip)">
      <div slot="form-item-annotation" class="annotation">* 1ファイルにつき最大500MB、<br>3ファイルまで添付できます</div>
      <field-container>
        <field-file-input name="files"
                          v-model="files"
                          :multiple="true"
                          :limit="3"
                          :acceptExtensions="['jpg', 'jpeg', 'png', 'gif', 'xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'pdf', 'txt', 'csv', 'zip']"
                          invalidAcceptFileMessage="このファイルは添付できません。<br>添付できるファイルは下記になります。<br>・画像ファイル(jpg, jpeg, png, gif)<br>・ドキュメントファイル(doc, docx, xls, xlsx, ppt, pptx, pdf)<br>・テキストファイル(txt, csv)<br>・圧縮ファイル(zip)"
        ></field-file-input>
      </field-container>
    </form-item-container>
  </form-container>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible=false">キャンセル</el-button>
      <el-button type="primary" @click="onClickCreate">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import WebApiClient from '../../../api/web'
import CommonUtil from '../../../utils/common'
import {Code} from '../../../api/base'

export default {
  name: 'SupportCreateCmp',
  components: {},
  props: {
    supportId: {type: String, default: null},
    subject: '',
    categoryId: {type: String, default: null},
    categoryName: ''
  },
  data () {
    return {
      body: '',
      files: [],
      visible: true,
      supportCategories: []
    }
  },
  created () {
    if (CommonUtil.isEmpty(this.supportId)) {
      WebApiClient.getSupportCategories(this).then(response => {
        this.supportCategories = response.data.result.supportCategories
        this.$forceUpdate()
      })
    }
  },
  methods: {
    onClickCreate () {
      this.$refs.form.$validator.validateAll().then((result) => {
        if (result) {
          if (CommonUtil.isEmpty(this.supportId)) {
            WebApiClient.postSupports(this, {
              categoryId: this.categoryId,
              subject: this.subject,
              body: this.body
            }, this.files).then(response => {
              if (response.data.code === Code.SUCCESS) {
                this.visible = false
                this.$emit('added')
              }
            })
          } else {
            WebApiClient.postSupportCommunications(this, this.supportId, {
              body: this.body
            }, this.files).then(response => {
              if (response.data.code === Code.SUCCESS) {
                this.visible = false
                this.$emit('updated')
              }
            })
          }
        }
      })
    }
  }
}

</script>

<style type="scss" scoped>
  .required {
    color: #d8243e;
  }

  .support-create-container {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/support/dialogs/create.vue